/**
 * Featured Product Slider (ACF block)
 * Initializes `.products-slider` within the block.
 */

document.querySelectorAll('.featured-product-slider-block .products-slider').forEach(function (item) {
    if (typeof Swiper === 'undefined') {
        return;
    }

    item.querySelectorAll('.loop-product-column').forEach(e => e.classList.add('swiper-slide'));

    new Swiper(item, {
        loop: false,
        init: true,
        spaceBetween: 15,
        pagination: {
            el: item.querySelector('.products-slider-slider') || '.products-slider-slider',
            clickable: true,
        },
        slidesPerView: 'auto',
        navigation: {
            prevEl: item.closest('.slider')?.querySelector('.swiper-button-prev'),
            nextEl: item.closest('.slider')?.querySelector('.swiper-button-next')
        },
        breakpoints: {
            470: {
                spaceBetween: 15,
                slidesPerView: 'auto',
            },
            756: {
                spaceBetween: 20,
                slidesPerView: 2,
            },
            992: {
                spaceBetween: 30,
                slidesPerView: 3,
            },
            1200: {
                spaceBetween: 40,
                slidesPerView: 3,
            },
        },
        slideContent: '.swiper-wrapper',
    });
});


